import type { TimelineVisit } from '../domain/models';
import { formatDateTime } from '../domain/time';
import { ConfidenceBadge } from './ConfidenceBadge';

export function VisitTable({ visits }: { visits: TimelineVisit[] }) {
  if (visits.length === 0) {
    return <div className="surface map-empty">滞在候補はありません</div>;
  }

  return (
    <div className="surface table-wrap">
      <table>
        <thead>
          <tr>
            <th>開始</th>
            <th>終了</th>
            <th>地点</th>
            <th>滞在</th>
            <th>半径</th>
            <th>確度</th>
            <th>source</th>
          </tr>
        </thead>
        <tbody>
          {visits.map((visit) => (
            <tr key={visit.id}>
              <td>{formatDateTime(visit.startTime)}</td>
              <td>{formatDateTime(visit.endTime)}</td>
              <td>{visit.placeName ?? `${visit.center.lat.toFixed(4)}, ${visit.center.lng.toFixed(4)}`}</td>
              <td>{Math.round(visit.durationMinutes)} 分</td>
              <td>{Math.round(visit.radiusMeters)} m</td>
              <td>
                <ConfidenceBadge confidence={visit.confidence} />
              </td>
              <td>{visit.source}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
